import * as TimeConstant from "./TimeConstant";
export { TimeConstant };
